import React, { useState } from "react";
import { FaArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import ProductOptions from "./ProductOptions";
import { InventoryServices } from "../services/InventoryServices";

const Items = ({ updateState, setUpdateState, inventory }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);

  const handleClick = (productId) => {
    setItemToRemove(productId);
    setShowOptions(true);
  };

  const handleDeleteItem = async () => {
    if (!itemToRemove) return;
    const response = await InventoryServices.deleteItem(itemToRemove);
    if (!response.success) {
      console.log("There was an error", response);
      return;
    }
    setShowOptions(false);
    setUpdateState(!updateState);
  };

  return (
    <>
      <div className="item">
        {inventory && inventory.length > 0 ? (
          inventory.map((item, index) => (
            <div key={index} style={{ display: "flex", width: "100vw" }}>
              <Link
                to={`/manager/inventory/${item?._id}`}
                className={`inventory-products ${
                  index % 2 === 0 ? "even" : "odd"
                }`}
              >
                <div className="inventory-products-left">
                  <img src={item.images[0]} alt={item.metadata} />
                  <div className="inner-flex">
                    <p>{item.name}</p>
                    <span>{item.category}</span>
                  </div>
                  <p>${item.price}</p>
                </div>

                <div className="inventory-products-right">
                  <p>
                    {item.stockStatus} <FaArrowDown />
                  </p>
                </div>
              </Link>

              {/* 3-dot options trigger */}
              <div className="three-dots" onClick={() => handleClick(item._id)}>
                <p>.</p>
                <p>.</p>
                <p>.</p>
              </div>
            </div>
          ))
        ) : (
          <p className="no-products">Products you add will show up here</p>
        )}
      </div>

      {/* Modal Overlay */}
      {showOptions && (
        <ProductOptions
          isOpen={showOptions}
          onClose={() => setShowOptions(false)}
          handleDeleteItem={handleDeleteItem}
        />
      )}
    </>
  );
};

export default Items;
